import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { countryStateApiDao } from 'shared/dao/countryStateApiDao';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';
import {
  ICityResponsePayload,
  ICountryResponsePayload,
  IStateResponsePayload,
  ICountryPhoneCodeResponsePayload,
} from 'shared/interfaces/utils/ICountryStateApi';

const {
  getCountries: getCountriesDao,
  getStatesByCountry: getStatesByCountryDao,
  getCitiesByStateAndCountry: getCitiesByStateAndCountryDao,
  getPhoneCodeByCountry: getPhoneCodeByCountryDao,
  getAllStates: getAllStatesDao,
} = countryStateApiDao();
export const countryStateApiService = () => {
  const getCountries = () => {
    return useQuery<ICountryResponsePayload, IAxiosErrorResponse, ICountryResponsePayload>(['country'], () =>
      getCountriesDao(),
    );
  };

  const getStatesByCountry = (
    countryCode: string,
    options?: Omit<
      UseQueryOptions<IStateResponsePayload, IAxiosErrorResponse, IStateResponsePayload, QueryKey>,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useQuery<IStateResponsePayload, IAxiosErrorResponse, IStateResponsePayload>(
      ['state', countryCode],
      () => getStatesByCountryDao(countryCode),
      options,
    );
  };

  const getCitiesByStateAndCountry = (
    countryCode: string,
    stateCode: string,
    options?: Omit<
      UseQueryOptions<ICityResponsePayload, IAxiosErrorResponse, ICityResponsePayload, QueryKey>,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useQuery<ICityResponsePayload, IAxiosErrorResponse, ICityResponsePayload>(
      ['city', countryCode, stateCode],
      () => getCitiesByStateAndCountryDao(countryCode, stateCode),
      options,
    );
  };

  const getPhoneCodeByCountry = (
    countryCode: string,
    options?: Omit<
      UseQueryOptions<
        ICountryPhoneCodeResponsePayload,
        IAxiosErrorResponse,
        ICountryPhoneCodeResponsePayload,
        QueryKey
      >,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useQuery<ICountryPhoneCodeResponsePayload, IAxiosErrorResponse, ICountryPhoneCodeResponsePayload>(
      ['phone_code', countryCode],
      () => getPhoneCodeByCountryDao(countryCode),
      options,
    );
  };

  const getAllStates = () => {
    return useQuery<IStateResponsePayload, IAxiosErrorResponse, IStateResponsePayload>(['state'], () =>
      getAllStatesDao(),
    );
  };

  return {
    getCountries,
    getStatesByCountry,
    getCitiesByStateAndCountry,
    getPhoneCodeByCountry,
    getAllStates,
  };
};
